// ===================================
// CULQI CONFIGURATION
// ===================================
// Culqi's PUBLIC key is safe to ship in frontend code — it can only be used
// to open the tokenizing checkout, never to charge a card. Get yours from
// https://culqi.com > Llaves > Llave pública, and replace the value below.
//
// The matching SECRET key must NEVER go here or anywhere in the frontend —
// it belongs only in the backend's .env as CULQI_SECRET_KEY
// (see backend/.env.example).
export const CULQI_PUBLIC_KEY = "pk_test_REPLACE_WITH_YOUR_CULQI_PUBLIC_KEY";

export function isCulqiConfigured() {
  return Boolean(CULQI_PUBLIC_KEY) && !CULQI_PUBLIC_KEY.includes("REPLACE_WITH");
}
